import { IgGrayPrimitives } from "@intelligems/ig-design-tokens";
import { SxProps } from "@mui/material";

// Marks an element so react-grab's pointer handlers skip it (they check the
// event's composedPath), keeping our own UI from being grabbed in select mode.
export const REACT_GRAB_IGNORE_ATTR = "data-react-grab-ignore-events";

export const Z_INDEX_LEVELS = {
  bottom: 2147483645,
  top: 2147483646,
  // Ties with react-grab's overlay host (max int32). Dialogs portal to the
  // end of <body> when opened — after the host, which mounts at page init —
  // so the tie resolves in the dialog's favor and react-grab's post-copy
  // flash stays underneath.
  dialog: 2147483647,
};

export const DESIGN_TOKENS: Record<string, SxProps> = {
  button: {
    color: IgGrayPrimitives[300],
    background: "transparent",
    minHeight: "0 !important",
    minWidth: 0,
    padding: 1.5,
    // Highlight for the Select button while react-grab selection mode is active.
    '&[data-active="true"]': {
      background: IgGrayPrimitives.A500,
    },
    "& .lucide": {
      color: IgGrayPrimitives[900],
    },
    "&:not([data-active='true']):hover .lucide": {
      color: IgGrayPrimitives.A600,
    },
  },
  container: {
    background: IgGrayPrimitives.A600,
    borderRadius: 1,
    gap: 0.5,
    padding: 0.5,
    width: "fit-content",
  },
  divider: {
    background: IgGrayPrimitives.A400,
    height: "12px",
    margin: 1,
  },
  panel: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    height: "40vh",
    zIndex: Z_INDEX_LEVELS.bottom,
  },
};
